import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const community = {
	// 创建用户默认社群身份
	createCommunityInfo: token => {
		return api.post(proxyApi + `/v3/cv_accounts/${token}/community_identity`)
	},
	// 获取用户社群身份信息
	getCommunityInfo: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${token}/identify_info`)
	},
	// 更新用户社群身份信息
	updateCommunityInfo: data => {
		return api.put(proxyApi + `/v3/cv_accounts/${data.rest}/community_identity`, data.body)
	},
	// 判断有没有昵称
	checkUserName: cv_account_token => {
		return api.get(proxyApi + `/v3/cv_accounts/${cv_account_token}/basic_info/check`)
	},
  // 获取 微信群配置列表
	getGroupsInfo: () => {
		return api.get(proxyApi + `/v1/wx_groups`)
	}
}

export default community
